/*
 * @prettier
 * @copyright (c) 2019 - present, HGC-AB
 * @licence This source code is licensed under the MIT license described and found in the
 * LICENSE file in the root directory of this source tree.
 */


/**
 * Function that groups an array of object, based normally on a property
 * in the objects byt this time we building our own key to group by
 * @param edges
 * @returns {*}
 */
export function groupByDate(edges) {
  return edges.reduce((acc, edge) => {
    const { node: { frontmatter: { date } } } = edge
    const key = date

    if (!acc[key]) {
      acc[key] = []
    }

    acc[key].push({ ...edge.node.fields, ...edge.node.frontmatter })

    return acc
  }, {})
}
